var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#01447a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m718.8 328.8c-12 0-21.602 9.6016-21.602 21.602v72l190.8-0.003906v-72c0-12-9.6016-21.602-21.602-21.602z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.6 328.8c-12 0-21.602 9.6016-21.602 21.602v72h190.8v-72c0-12-9.6016-21.602-21.602-21.602z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m250.8 350.4c0-45.602 37.199-81.602 81.602-81.602h147.6c45.602 0 81.602 37.199 81.602 81.602v72h74.395v-72c0-45.602 37.199-81.602 81.602-81.602h147.6c45.602 0 81.602 37.199 81.602 81.602v72h84l-0.003907-181.2c0-42-33.602-75.602-75.602-75.602l-712.8 0.003906c-42 0-75.602 33.602-75.602 75.602v181.2h84z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1161.6 714-121.2-231.6h-880.8l-121.2 231.6c-6 10.801-8.3984 22.801-8.3984 34.801v265.2c0 10.801 9.6016 20.398 20.398 20.398h63.602c10.801 0 20.398-9.6016 20.398-20.398v-84h930v84c0 10.801 9.6016 20.398 20.398 20.398h63.602c12 0 20.398-9.6016 20.398-20.398l0.003906-265.2c1.1992-12-1.1992-24-7.1992-34.801z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoom);
export default __webpack_public_path__ + "static/media/room.b5cacaada3bbabb1db19f7b35080d85b.svg";
export { ForwardRef as ReactComponent };